import Vue from 'vue'
import Router from 'vue-router'
import BecomeMember from '@/pages/BecomeMember'
import MainPage from '@/pages/MainPage'
import FrontPage from '@/pages/FrontPage'
import FourOFour from '@/pages/FourOFour'
import Organisasjonen from '@/pages/Partiet'
import Politikken from '@/pages/Politikken'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(VeeValidate)
Vue.use(VueResource)
Vue.use(Meta)

export default new Router({
  routes: [
    {
      path: '/404',
      name: '404',
      component: FourOFour
    },
    {
      path: '/',
      name: 'FrontPage',
      component: FrontPage,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/organisasjonen',
      name: 'Organisasjonen',
      component: Organisasjonen,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/politikken',
      name: 'Politikken',
      component: Politikken,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/bli-medlem',
      name: 'BecomeMember',
      component: BecomeMember
    },
    {
      path: '/:slug',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/*',
      redirect: {
        name: '404'
      }
    }
  ],
  mode: 'history',
  saveScrollPosition: true,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js